<template>
  <div class="Product">
    <div class="Product_img">
      <img :src="headerimg[header].img"/>
    </div>
    <div class="left" @click="left">&lt;</div>
    <div class="right" @click="right">&gt;</div>
    <div class="list_list">
      <div
          class="list"
          :key="index"
          @click="change(index)"
          :class="header==index ? 'Active':''"
          @mouseout="plays"
          @mouseover="stop(index)"
          v-for="(Header,index) in oitem"
      >
          <img :src="Header.img">
      </div>
    </div>

    <div class="community_right">
      <div class="fullPageContainer">
        <div
            class="fullPageContainer_img"
            v-for="(item,index) in imgurl"
            :key="index"
            @mouseout="play"
            @click="Img(index)"
            @mouseover="Img(index)"
            :class="oindex==index ? 'active':''"

        >
          <img :src="item.img"/>
        </div>
      </div>
    </div>

    <div class="community">
      <div class="community_text">
        <div class="community_title">
          <h1>{{ img[oindex].title }}</h1>
        </div>
        <div class="community_left">
          <p>{{ img[oindex].content }}</p>
        </div>
      </div>
      <div class="community_img">
        <div>
          <img :src="img[oindex].img" alt=""/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      header: 0,
      timer: null,
      time: null,
      activeIndex: '0',
      oindex: 0,
      img: [
        {
          img: require('../assets/社区文化.png'),
          title: '社区文化',
          content: '社区文化本质上是一种家园文化，具有社会性、开放性和群众性的特点, \n' +
              '发展社区文化，可以强化社区群众的主人翁意识，倡导特有的健康的民风民俗, \n' +
              '增强社区居民的归属感，维系社区良好的人际关系，提高居民的生活质量。社区文化区块由社委会管理，发布社区的文化等资讯。'
        },
        {
          img: require('../assets/生活资讯.png'),
          title: '生活资讯',
          content: '生活资讯是消费者因为及时的获得它并利用它而能够在相对短的时间内给自己带来价值的信息为生存发展而进行各种活动\n' +
              '        社区人员都可以在此区块发布可以一起互动的生活板块'
        },
        {
          img: require('../assets/拼一拼.png'),
          title: '拼一拼',
          content: '拼一拼是专门为了提高社区活跃度、降低团购门槛而设立的区块，各种拼，让生活更便利更实惠更由乐趣。'
        },
        {
          img: require('../assets/跳蚤市场.png'),
          title: '跳蚤市场',
          content: '扔了可惜不扔占地，小跳蚤直接带走你的烦恼，让家庭里的闲置物品再发挥它的使用价值。'
        },
        {
          img: require('../assets/活动中心.png'),
          title: '活动中心',
          content: '丰富社区的活力，参加社区活动享受活动带来的乐趣与活力，居民可发起活动，活跃社区生活。'
        },
        {
          img: require('../assets/互助站.png'),
          title: '互助站',
          content: '你顺手、我顺路，邻里互助各得其利，有什么需要邻里帮忙的，可以让大家一起出力。'
        },
        {
          img: require('../assets/问卷投票.png'),
          title: '问卷投票',
          content: '在线调查，手指只要动一动，朋友的想法都会往锦囊里跳，再不需要挨家挨户进行收集调查表了。'
        },
        {
          img: require('../assets/社委中心.png'),
          title: '社委中心',
          content: '解放传统的管理方案，一则公告就能提醒居民，社区管理人员可以对居民进行审核及发布内容进行管理'
        }
      ],
      imgurl: [],
      oitem:[
        {
          img: require('../assets/list.png'),
        },
        {
          img: require('../assets/list.png')
        },
        {
          img: require('../assets/list.png')
        },
        {
          img: require('../assets/list.png')
        }
      ],
      headerimg: [
        {
          img: require('../assets/logo-img.png')
        },
        {
          img: require('../assets/imq1.png')
        },
        {
          img: require('../assets/imq2.png')
        },
        {
          img: require('../assets/imq3.png')
        }
      ],
    };
  },
  methods: {
    change: function (index){
      this.header = index;
    },
    left: function () {
      this.header--;
      if(this.header == -1){
        this.header = this.headerimg.length -1;
      }
    },
    right: function (){
      this.header++;
      if(this.header == this.headerimg.length){
        this.header = 0;
      }
    },
    Img: function (index) {
      this.oindex = index;
      clearInterval(this.timer)
    },
    play: function () {
      this.timer = setInterval(this.autoPlay, 2000)
    },
    autoPlay: function () {
      this.oindex++;
      if (this.item == this.img.length) {
        this.item = 0;
      }
      if (this.oindex == this.img.length) {
        this.oindex = 0;
      }
    },
    stop: function () {
      clearInterval(this.time)
    },
    plays: function () {
      this.time = setInterval(this.autoPlays,2000)
    },
    autoPlays: function () {
      // this.header++;
      if(this.Header == this.headerimg.length){
        this.Header = 0;
      }
    }
  },
  mounted() {
    this.imgurl = [
      {
        img: require('../assets/other/社区文化.png')
      },
      {
        img: require('../assets/other/生活资讯.png'),
      },
      {
        img: require('../assets/other/拼一拼.png')
      },
      {
        img: require('../assets/other/小跳瘙.png')
      },
      {
        img: require('../assets/other/活动中心.png')
      },
      {
        img: require('../assets/other/互助站.png')
      },
      {
        img: require('../assets/other/问卷调查.png')
      },
      {
        img: require('../assets/other/社委中心.png')
      }
  ]
    this.plays()
    this.play();
  }
}
</script>

<style scoped>
.Product_img {
  text-align: center;
  width: 100%;
  margin: 0 auto;
}

.list_list{
  display: flex;
  margin: 0 auto;
  width: 11%;
  background-color: white;
  margin-top: -34px;
  height: 30px;
}

.list{
  background-color: #30d5c8;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin: 0 10px;
}

.list>img{
  background-color: #30d5c8;
  border-radius: 50%;
  width: 15px;
  height: 15px;
}

.list.Active{
  transform: scale(1.3);
}


.left{
  cursor: pointer;
  position: absolute;
  top: 40%;
  font-size: 50px;
  color: #30d5c8;
  left: 18.65%;
}

.right{
  cursor: pointer;
  position: absolute;
  top: 40%;
  color: #30d5c8;
  font-size: 50px;
  left: 79%;
}

.Product_img > img {
  border-radius: 5px;
  margin-top: 90px;
  width: 860px;
  height: 400px;
}

.community {
  display: flex;
  width: 63%;
  margin: 30px auto;
  height: 400px;
}

.community_title {
  text-align: center;
  font-family: 华文宋体;
}

.community_left {
  margin: 0 auto;
  text-indent: 2em;
  font-family: 华文宋体;
  width: 80%;
}

.community_left > p {
  float: left;
}

.community_text {
  width: 50%;
  height: 256px;
}

.community_img {
  width: 50%;
  background-color: white;
}

.community_img > div {
  margin: 0 auto;
  background-color: white;
  border: 1px solid #fff;
  width: 300px;
  height: 410px;
  overflow: hidden;
}

.community_img > div > img {
  margin: -2px auto;
  height: 415px;
  width: 310px;
  border: 1px solid #fff;
}

.community_children > img {
  width: 50%;
}

.community_right {
  height: 80px;
  width: 62%;
  margin: 30px auto;
  text-align: center;
}

.fullPageContainer {
  margin: 0 auto;
  cursor: pointer;
  height: 100%;
  width: 100%;
}

.fullPageContainer_img {
  margin: 16px 2%;
  display: inline-block;
  width: 60px;
  text-align: center;
  height: 60px;
}

.fullPageContainer_img.active{
  transform: scale(1.35);
}

.fullPageContainer_img > img{
  width: 100%;
  height: 100%;
}
</style>